module.exports = __webpack_public_path__ + "static/media/quillbot-design_process.e216bd53.png";